import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { QuotationMaster } from '../../TitleList';
import { fetchQuotatuionData } from '../../../Store/PHPSlice/Sale/Quotation';
import { selectQuotData } from '../../Selectors/Master/ItemSelectors';


const QuotationTable = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    const quotationlist = useSelector(selectQuotData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchQuotatuionData());
    }, [dispatch]);


    const compData = Array.isArray(quotationlist.data) ? quotationlist.data.map((item, index) => (
        {
            srno: item.ID,
            quotNo: item.quotNo,
            dt: item.date,
            partyNm: item.partyNm,
            firmNm: item.firmNm,
            grpNm: item.grpNm,
            schoolNm: item.schoolNm,
            itemNm: item.itemNm,
            jobrate: item.jobrate,
            extra: item.extra,
            clothNm: item.clothNm,
            rate: item.rate,
            m1clothNm: item.m1clothNm,
            m1rate: item.m1rate,
            m2clothNm: item.m2clothNm,
            m2rate: item.m2rate,
            m3clothNm: item.m3clothNm,
            m3rate: item.m3rate,
            outSrc: item.outSrc,
            nar: item.nar,
            sts: item.sts,
            userId: item.userid,
            userNm: item.userNm,
            del_sts: item.del_sts,
            serialNumber: index + 1
        }
    )) : [];

    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });


    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.quotNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.schoolNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.partyNm?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    const headCells = [
        { id: 'srno', label: 'SrNo' },
        { id: 'price', label: 'Price' },
        { id: 'info', label: 'Info' },
        { id: 'excel', label: 'Excel' },
        { id: 'changeRate', label: 'Change Price' },
        // { id: 'analysis', label: 'Analysis' },
        { id: 'dt', label: 'Date' },
        { id: 'quotNo', label: 'Quotation No' },
        { id: 'firmNm', label: 'Firm' },
        { id: 'partyNm', label: 'Party' },
        { id: 'schoolNm', label: 'School' },
        // { id: 'itemNm', label: 'Item' },
        // { id: 'clothNm', label: 'Main Cloth' },
        // { id: 'rate', label: 'Main Rate' },
        // { id: 'm1clothNm', label: 'Match-1 Cloth' },
        // { id: 'm1rate', label: 'Match-1 Rate' },
        // { id: 'm2clothNm', label: 'Match-2 Cloth' },
        // { id: 'm2rate', label: 'Match-2 Rate' },
        // { id: 'm3clothNm', label: 'Match-3 Cloth' },
        // { id: 'm3rate', label: 'Match-3 Rate' },
        // { id: 'jobrate', label: 'JobRate' },
        // { id: 'extra', label: 'Extra' },
        // { id: 'nar', label: 'Naration' },
        { id: '', label: 'Delete' },
    ];

    if (userdata?.role === '1') {
        headCells.push({ id: 'userNm', label: 'User' });
    }

    return (
        <>
            <Titlebar data={QuotationMaster} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Quotation Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={headCells}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>


                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                quotNo={row.quotNo}
                                                dt={row.dt}
                                                partyNm={row.partyNm}
                                                firmNm={row.firmNm}
                                                schoolNm={row.schoolNm}
                                                itemNm={row.itemNm}
                                                clothNm={row.clothNm}
                                                rate={row.rate}
                                                m1clothNm={row.m1clothNm}
                                                m1rate={row.m1rate}
                                                m2clothNm={row.m2clothNm}
                                                m2rate={row.m2rate}
                                                m3clothNm={row.m3clothNm}
                                                m3rate={row.m3rate}
                                                jobrate={row.jobrate}
                                                extra={row.extra}
                                                nar={row.nar}
                                                sts={row.sts}
                                                del_sts={row.del_sts}
                                                userNm={row.userNm}
                                                userId={row.userId}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default QuotationTable;
